/**
 * Lightbinder ability clips. The clips themselves live in ../kits/lightbinder.ts (staff twirls in
 * holy gold, white and rose-gold); this file only registers them. Abilities not registered there
 * play the class defaults (../defaults.ts).
 */
import { registerLightbinderKit } from '../kits/lightbinder';

export function registerLightbinderClips(): void {
  registerLightbinderKit();
}
